/* eslint-disable import/no-cycle */
import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';
import votingRubric from '@/constants/votingRubric';
import authorization from './modules/authorization.module';

Vue.use(Vuex);

const vuexLocalStorage = new VuexPersist({
  key: 'acv-hackathon', // The key to store the state on in the storage provider.
  storage: window.localStorage, // or window.sessionStorage or localForage
});

const store = new Vuex.Store({
  plugins: [
    vuexLocalStorage.plugin,
  ],
  modules: {
    authorization,
  },
  state: {
    count: 0,
    categories: votingRubric.categories,
    teams: [],
    votes: [],
    admins: [],
    eventState: '', // Setup, Registration, Hacking, Judging, PrizeSelection, Completed
    eventNotes: '',
    hackathonID: '',
    hackathonName: 'Hackathon Participants Login',
    maxUsers: 4, // will be overwritten by event response
    begins: null,
    ends: null,
    presentationTimeSeconds: null,
    teamsListView: false,
  },
  getters: {
    currentHackathonId(state) {
      return state.hackathonID;
    },
    eventState(state) {
      return state.eventState;
    },
    admins(state) {
      return state.admins;
    },
    haveTeamsListView(state) {
      return state.teamsListView;
    },
    presentationTimeSeconds(state) {
      return state.presentationTimeSeconds;
    },
    eventNotes(state) {
      return state.eventNotes;
    },
  },
  actions: {
    setEvent({ commit, getters, dispatch }, currentEvent) {
      commit('setEvent', currentEvent);
      // add a check to update currentUser
      if (currentEvent !== undefined && currentEvent?.admins) {
        /* eslint-disable-next-line max-len */
        const currentUserIsAdmin = currentEvent?.admins.map((adminObj) => adminObj.email).indexOf(getters.currentUser?.email) > -1;
        dispatch('setUserAdminStatus', currentUserIsAdmin);
      }
    },
    setTeamsListView({ commit }, newTeamListVal) {
      commit('setTeamsListView', newTeamListVal);
    },
    setUserAdminStatus({ commit }, newStatus) {
      commit('setUserAdminStatus', newStatus);
    },
    setUserTeam({ commit }, newTeam) {
      commit('setUserTeam', newTeam);
    },
    setPresentationTime({ commit }, seconds) {
      commit('setPresentationTime', seconds);
    },
  },
  mutations: {
    setEvent(state, currentEvent) {
      state.hackathonName = currentEvent?.name || 'ACV Hackathon';
      state.eventState = currentEvent?.state || 'Setup';
      state.hackathonID = currentEvent?.id || '';
      state.maxUsers = currentEvent?.maxTeamSize || 4;
      state.begins = currentEvent?.begins;
      state.ends = currentEvent?.ends;
      state.admins = currentEvent?.admins;
      state.presentationTimeSeconds = currentEvent?.presentationTimeSeconds;
      state.eventNotes = currentEvent?.notes;
    },
    setTeams({ getters, state, dispatch }, apiTeams) {
      state.teams = apiTeams;
      // find out which team the current user belongs to, if any
      state.teams.forEach((team) => {
        team.members.forEach((member) => {
          if (member.email === getters.currentUser.email) {
            dispatch('setUserTeam', team.id);
          }
        });
      });
    },
    setTeamsListView(state, newTeamListVal) {
      state.teamsListView = newTeamListVal;
    },
    setPresentationTime(state, seconds) {
      state.presentationTimeSeconds = seconds;
    },
    setVoteInfo(state, voteInfo) {
      state.teams[voteInfo.teamIndex].voteInfo = voteInfo.teamVote;
    },
    addNewTeam({ dispatch, state }, newTeam) {
      state.teams = [newTeam, ...state.teams];
      // we assume the person who creates the team is the leader,
      // although this is done on the backend
      dispatch('setUserTeam', newTeam.id);
    },
    removeMember(state, payload) {
      const teamToUpdate = payload.team;
      const { userId } = payload;
      const cleanedMembers = teamToUpdate.members.filter((member) => member !== userId);
      const updatedTeam = {
        id: teamToUpdate.id,
        name: teamToUpdate.name,
        img: '',
        leader: teamToUpdate.leader,
        members: cleanedMembers,
        description: teamToUpdate.description,
        joinCode: teamToUpdate.joinCode,
      };
      const cleanedTeams = state.teams.filter((team) => team.id !== teamToUpdate.id);
      cleanedTeams.splice(teamToUpdate.id, 0, updatedTeam);
      state.teams = cleanedTeams;
    },
    removeTeam(state, teamToRemove) {
      // unassign team from leader and members
      const usersToUpdate = state.users.filter((user) => user.id === teamToRemove.leader
        || teamToRemove.members.indexOf(user.id) > -1);
      usersToUpdate.forEach((userToUpdate) => {
        // this is not going to be very efficient but we can always refactor later
        state.users.forEach((user) => {
          if (user.id === userToUpdate.id) {
            /* eslint-disable-next-line no-param-reassign */
            user.team = '';
          }
        });
      });
      // then remove the team
      const cleanedTeams = state.teams.filter((team) => team.id !== teamToRemove.id);
      state.teams = cleanedTeams;
    },
  },
});

export default store;
